import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { transformFieldData, getBackendUrl } from "@/utils/util";

export default function API_Calls_Preview() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const getPreviewSummary = async (affiliate, ada_file) => {
    // ada_file,
    // --> ${processTimeStamp}/${affiliateFileData.name}
    // @${affiliateFileData.created}/${templateData.name}@${templateData.created}

    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      ada_file,
    });
    const previewSummary = await apiCall({
      url: `${backendUrl}/api/summary?${queryString}`,
      headers,
    });
    if (
      !previewSummary.error &&
      previewSummary.data &&
      Array.isArray(previewSummary.data.field_data)
    ) {
      previewSummary.data.field_data = transformFieldData(
        previewSummary.data.field_data
      );
    } else {
      console.error("Error or unexpected data structure:", previewSummary);
    }
    return previewSummary;
  };

  const confirmPreviewSummary = async (affiliate, ada_file) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      ada_file,
    });
    return apiCall({
      url: `${backendUrl}/api/summary?${queryString}`,
      method: "PATCH",
      headers,
    });
  };

  const unstageFromVan = async (affiliate, ada_file, reason) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      ada_file,
      reason,
    });
    return apiCall({
      url: `${backendUrl}/api/unstage?${queryString}`,
      method: "PATCH",
      headers,
    });
  };

  const setFileAsIEB = async (affiliate, processedDate) => {
    // value is processed date to set, null to unset
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      setting: "ieb_file",
      value: processedDate,
    });
    return apiCall({
      url: `${backendUrl}/api/preferences?${queryString}`,
      method: "PUT",
      headers,
    });
  };

  return {
    getPreviewSummary,
    confirmPreviewSummary,
    unstageFromVan,
    setFileAsIEB,
  };
}
